import { requireStates } from "util";
import { ConnectComponent2 } from "util";
import View from "./view";
import Presenter from "./presenter";

const initialStates = [
  {
    name: "app.registration.payment",
    url: "/pagamentos",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    },
    data: {
      navigation: {
        priority: 800,
        name: "Pagamentos",
        state: "app.registration.payment"
      },
      authorization: () => true
    }
  }
];

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);
const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/payment/index.js